module.exports = __webpack_public_path__ + "5c114213/img/trash-icon.ff8201c7.svg";